import { Box, Card } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { captureEvent } from '../../../../services/event-capture';
import { selectAllCourseCategories } from '../../../../services/store/modules/courses';
import { CourseCategoryModel } from '../../../../services/store/modules/courses/models';
import TileImage from '../../../shared/TileImage/TileImage';
import LogoSpinner from '../../../shared/_deprecated/components/LogoSpinner/LogoSpinner';

const CourseCategoriesPage: FC = () => {
  const categories = useSelector(selectAllCourseCategories);

  const handleSelectCategory = (category: CourseCategoryModel) => {
    captureEvent({
      type: `courses: select category (${category.name})`,
      payload: {},
      sendToAmplitude: true,
    });
  };

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      boxSizing="border-box"
      p="3"
      justifyContent="space-between"
    >
      {categories.length === 0 && <LogoSpinner />}
      {categories.length > 0 && (
        <Card>
          <Card.Heading>Improve your skills</Card.Heading>
          <Card.Body>
            Explore online courses designed by experts to help you enjoy your
            time on the water with confidence.
          </Card.Body>
        </Card>
      )}
      {categories.map((category) => (
        <Box key={category.name} flex="0 0 48%" minHeight="175px" my="2">
          <TileImage
            key={category.id}
            imageUrl={category.imageUrl}
            url={{
              pathname: `/maps/courses/list`,
              search: `category=${category.id}`,
            }}
            onClick={() => handleSelectCategory(category)}
            name={category.name}
          />
        </Box>
      ))}
    </Box>
  );
};

export default CourseCategoriesPage;
